import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
function Collaborators() {
  const [inCollabBody, setInCollabBody] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const urlArr = location.pathname.split("/");
  const url = urlArr[urlArr.length - 1];
  // const netlifyUrl =
  //   "http://localhost:8888/.netlify/functions/publication-function";
  const netlifyUrl =
    "https://dratunroychoudhury.netlify.app/.netlify/functions/publication-function";
  const regex = /(https?:\/\/.*\.(?:png|jpg|jpeg))/i;
  const urlRegex = /^(https?:\/\/[^\s]+)$/i;

  useEffect(() => {
    window.scrollTo(0, 200);
    async function netlifyFunc() {
      const res = await fetch(netlifyUrl, {
        method: "post",
        headers: { "Content-Type": "Application/json" },
        body: JSON.stringify({ url: url }),
      });
      const data = await res.json();
      console.log("data ", data);
      data.sort((a, b) => a["Sl. No."] - b["Sl. No."]);
      // console.log("check ", data[0], data[0]["Sl.No."]);
      // data.sort();
      data.sort((a, b) => a["Sl.No."] - b["Sl.No."]);
      console.log("sort ", data);
      setInCollabBody(data);
      setLoading(false);
    }
    netlifyFunc();
  }, [url]);
  return (
    <>
      {url === "national_collaborators" ? (
        <Typography variant="h4" sx={{ paddingTop: "2%" }}>
          Top National Collaborations
        </Typography>
      ) : url === "international_collaborators" ? (
        <Typography variant="h4" sx={{ paddingTop: "2%" }}>
          Top International Collaborations
        </Typography>
      ) : null}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        {loading ? (
          <InfinitySpin
            visible={true}
            height="196"
            width="196"
            color="green"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        ) : (
          <Box sx={{ fontSize: "large" }}>
            <table>
              <tr>
                {Object.keys(inCollabBody[0]).map((heading, ind) => {
                  return heading.toLowerCase() !== "url" ? (
                    <th key={ind}>{heading}</th>
                  ) : null;
                })}
              </tr>
              {inCollabBody.map((row, ind) => (
                <tr key={ind}>
                  {Object.keys(row).map((col) => {
                    const value = String(row[col]);
                    if (col.toLowerCase() === "url") return null;
                    if (value.match(regex)) {
                      const link = row["url"]; // get link from the DB row

                      const imageElement = (
                        <img
                          src={value}
                          alt={value}
                          style={{
                            height: "151px",
                            width: "150px",
                            borderRadius:
                              url !== "newspapers" &&
                              url !== "blogs" &&
                              url !== "books"
                                ? "50%"
                                : "0%",
                            border: "2px solid black",
                          }}
                        />
                      );

                      return (
                        <td key={col}>
                          {url === "newspapers" ||
                          url === "blogs" ||
                          url === "books" ? (
                            <a
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {imageElement}
                            </a>
                          ) : (
                            imageElement
                          )}
                        </td>
                      );
                    }
                    if (value.match(urlRegex)) return null;

                    return <td key={ind}>{value}</td>;
                  })}
                </tr>
              ))}
            </table>
          </Box>
        )}
      </Box>
    </>
  );
}

export default Collaborators;
